import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { usePaymentContext } from '../../store/payments/payments-context';
import { fetchProviderData, setProviders } from '../../store/payments/actions/providers';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router';
import { IProviderFiltersProps } from './ProviderFilters';
import { parseSearchParams } from '../../utils/utilities';

interface Props {
	fieldName: string;
	label: string;
	tooltipText?: string;
	value: boolean;
	setValue?: (value: boolean) => void;
	id: string;
	isDisabled?: boolean;
	additionalContainerClass?: string;
}

export const ProviderCheckbox: FC<Props> = (props) => {
	const {
		value, setValue, id, fieldName, isDisabled,
		label, tooltipText, additionalContainerClass
	} = props;
	const { search } = useLocation();

	const { dispatch } = usePaymentContext();

	const [localIsChecked, setLocalIsChecked] = useState<boolean>(value);
	const [loading, setLoading] = useState<boolean>(false);

	const filtersFromUrl: IProviderFiltersProps = parseSearchParams(search);

	const handleInputChange = async (): Promise<void> => {
		try {
			setLoading(true);
			let params;
			if (fieldName === 'supportMIT'
				|| fieldName === 'supportCIT'
				|| fieldName === 'useDynamicDescriptor'
				|| fieldName === 'useDynamicDescriptorSuffix'
				|| fieldName === 'supportUDF'
				|| fieldName === 'supportDynamicDescriptorUrl'
				|| fieldName === 'supportDynamicDescriptorAddress'
			) {
				params = {
					id,
					capabilities: {
						[fieldName]:value,
					}
				};
			} else {
				params = { [fieldName]:value, id };
			}
			setLocalIsChecked(!localIsChecked);
			if (setValue) {
				setValue(!localIsChecked);
			}

			if (fieldName === 'supportMIT'
				|| fieldName === 'supportCIT'
				|| fieldName === 'useDynamicDescriptor'
				|| fieldName === 'useDynamicDescriptorSuffix'
				|| fieldName === 'supportUDF'
				|| fieldName === 'supportDynamicDescriptorUrl'
				|| fieldName === 'supportDynamicDescriptorAddress'
			) {
				params.capabilities[fieldName] = !localIsChecked;
			} else {
				params[fieldName] = !localIsChecked;
			}
			await setProviders({ dispatch, params });
			await fetchProviderData({ dispatch, searchParams: filtersFromUrl });
			setLoading(false);
		} catch (e) {
			console.log(e);
			setLocalIsChecked(localIsChecked);

			if (setValue) {
				setValue(localIsChecked);
			}

			setLoading(false);
		}
	};

	return (
		<div className={clsx('d-flex col-6 col-md-3 mb-5', additionalContainerClass)}>
			<div className='form-check form-check-sm form-check-custom form-check-solid align-items-start'>
				<input
					className={clsx('form-check-input', isDisabled && 'cursor-not-allowed')}
					type='checkbox'
					checked={localIsChecked}
					onChange={(): Promise<void> => !isDisabled && handleInputChange()}
					disabled={loading}
				/>

					<label className="fs-7 text-muted ms-2 ">{label}</label>

					{
						tooltipText && (
								<WhisperComponent
									isTooltip
									whisperText={tooltipText}
									placement="auto"
									additionalClass="cursor-pointer ms-1"
									mainText={
										<FontAwesomeIcon
											icon={faQuestionCircle}
											width={12}
										/>
									}
								/>
						)
					}
			</div>
		</div>
	);
};

